import React from 'react'

import type { ReactNode } from 'react'
import type { PlayIconProps } from '@/pages/tad.ai/_components/PlayIcon'

import PlayIcon from '@/pages/tad.ai/_components/PlayIcon'


import { tw, cls } from 'tagged-classnames-free';
export interface ClipAudioContainerProps
  extends Pick<PlayIconProps, 'playing'> {
  children?: React.ReactNode
  className?: string
  contentClassName?: string
  extra?: ReactNode
  onClick?: () => void
}

function ClipAudioContainer(props: ClipAudioContainerProps) {
  const { children, extra, className, playing, contentClassName, onClick } =
    props
  return (
    <div
      className={tw`bg-f-bg-layout flex h-14 w-full overflow-hidden rounded-md ${className}`}
    >
      <div
        onClick={onClick}
        className={cls`bg-f-bg-active flex w-[50px] items-center justify-center rounded-md`}
      >
        <PlayIcon playing={playing} className={'size-8'} />
      </div>
      <div className={tw`flex-1 ${contentClassName}`}>{children}</div>
      {extra}
    </div>
  )
}

export default ClipAudioContainer
